<template>
    <div id="social-login-buttons">
        <b-form-group v-for="button in socialButtons" :key="button.name">
            <b-button @click.prevent="authProvider(button.provider)" :class="'btn-' + button.provider" block :style="{'background-color': button.color, border: 'none', 'border-radius': 0}">
                <span :class="button.icon"></span>
                {{ button.label }}
            </b-button>
        </b-form-group>
    </div>
</template>

<script>
    import Vue from 'vue'
    import axios from 'axios';
    import VueAxios from 'vue-axios';
    import {errors} from '../../mixins/errors';
    import VueSocialAuth from 'vue-social-auth';

    Vue.use(VueAxios, axios);

    Vue.use(VueSocialAuth, {
        providers: {
            facebook: {
                clientId: process.env.MIX_FACEBOOK_CLIENT_ID,
                redirectUri: process.env.MIX_FACEBOOK_REDIRECT_URL
            },
            google: {
                clientId: process.env.MIX_GOOGLE_CLIENT_ID,
                redirectUri: process.env.MIX_GOOGLE_REDIRECT_URL
            },
            linkedin: {
                clientId: process.env.MIX_LINKED_IN_CLIENT_ID,
                redirectUri: process.env.MIX_LINKED_IN_REDIRECT_URL,
                scope: ['r_emailaddress', 'r_liteprofile'],
            }
        }
    });

    export default {
        name: 'social-login-buttons',
        mixins: [errors],
        data() {
            return {
                socialButtons: [
                    // Facebook
                    {
                        color: '#4267B2',
                        icon: 'icon-facebook',
                        provider: 'facebook',
                        label: this.$t('login.button.social', {
                            social: 'Facebook'
                        })
                    },

                    // Google
                    {
                        color: '#DB4437',
                        icon: 'icon-social-media-google',
                        provider: 'google',
                        label: this.$t('login.button.social', {
                            social: 'Google'
                        })
                    },

                    // Linked-In
                    {
                        color: '#0E76A8',
                        icon: 'icon-professional-network-linkedin',
                        provider: 'linkedin',
                        label: this.$t('login.button.social', {
                            social: 'LinkedIn'
                        })
                    }
                ]
            }
        },
        methods: {
            authProvider(provider) {
                let self = this;

                this.$auth.authenticate(provider).then(response => {
                    self.socialLogin(provider, response)
                }).catch(err => {
                    console.error({err: err})
                })
            },
            socialLogin(provider, response) {
                this.$http.post('/auth/' + provider, response).then(response => {
                    if (response.data.status === 200) {
                        this.$store.dispatch('auth/socialLogin', {token: response.data.token, user: response.data.user});
                    }
                }).catch(err => {
                    console.error({err: err})
                })
            }
        }
    }
</script>
